__turbopack_context__.v({
  "actions": "W0KVcq_actions",
  "addToCartButton": "W0KVcq_addToCartButton",
  "container": "W0KVcq_container",
  "options": "W0KVcq_options",
  "optionsAndDonation": "W0KVcq_optionsAndDonation",
});
